var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UsersEditor", {
    attrs: {
      group: _vm.group,
      groupSelector: _vm.groupSelector,
      allUsers: _vm.allUsers
    },
    scopedSlots: _vm._u(
      [
        {
          key: "userButtonsBefore",
          fn: function({ groupUser }) {
            return [_vm._t("userButtonsBefore", null, { groupUser: groupUser })]
          }
        },
        {
          key: "userButtonsAfter",
          fn: function({ groupUser }) {
            return [_vm._t("userButtonsAfter", null, { groupUser: groupUser })]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }